import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "headline-5 w100" }
const _hoisted_2 = {
  class: "ion-hide-xs",
  style: {"height":"300px","width":"300px","min-width":"300px","max-width":"300px","overflow":"hidden","margin":"auto"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "headline-5 w100" }, "Breakdown by Question", -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "headline-5 w100" }, "Latest Articles", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_fav_modal_button = _resolveComponent("fav-modal-button")!
  const _component_info_button = _resolveComponent("info-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_single_circle = _resolveComponent("single-circle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_trend_block = _resolveComponent("trend-block")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_articles_feed = _resolveComponent("articles-feed")!
  const _component_skeleton_feed = _resolveComponent("skeleton-feed")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_resources_in_area = _resolveComponent("resources-in-area")!
  const _component_other_articles_box = _resolveComponent("other-articles-box")!
  const _component_upcoming_events_box = _resolveComponent("upcoming-events-box")!
  const _component_sidebar_box = _resolveComponent("sidebar-box")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { onClick: _ctx.scrollTop }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "ion-hide-lg-up"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification_bell, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_fav_modal_button, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_info_button, { category: _ctx.category }, null, 8, ["category"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadData($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_ion_grid, { class: "w100" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_grid, { class: "w100" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, { class: "mx-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, {
                                  "size-md": "6",
                                  "size-lg": "6",
                                  size: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.title), 1),
                                    _createElementVNode("div", _hoisted_2, [
                                      _createVNode(_component_single_circle, {
                                        scale: "0.9",
                                        size: 300,
                                        color: _ctx.hex,
                                        one: _ctx.latestCheckIn ? _ctx.latestCheckIn[_ctx.category] : 0
                                      }, null, 8, ["color", "one"])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_col, {
                                  "size-md": "6",
                                  "size-lg": "6",
                                  size: "12"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_3,
                                    _createVNode(_component_ion_row, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getQuestions, (t) => {
                                          return (_openBlock(), _createBlock(_component_ion_col, {
                                            "size-sm": "12",
                                            size: "12",
                                            key: t.id + '-trend'
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_4, [
                                                _createVNode(_component_trend_block, {
                                                  height: "unset",
                                                  detail: true,
                                                  category: t.id,
                                                  label: _ctx.getQuestions.find((q) => q.id == t.id).body,
                                                  color: _ctx.color
                                                }, null, 8, ["category", "label", "color"])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_row, { class: "ion-justify-content-center px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, { size: "12" }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (!_ctx.loading)
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 0,
                                  class: "ion-justify-content-center px-2 mx-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, {
                                      "size-lg": "12",
                                      "size-md": "12",
                                      size: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_articles_feed)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loading)
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 1,
                                  class: "ion-justify-content-center px-2 mx-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, {
                                      "size-lg": "12",
                                      "size-md": "10",
                                      size: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_skeleton_feed)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.innerWidth > 1400)
                      ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_sidebar_box, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_resources_in_area, { category: _ctx.title }, null, 8, ["category"]),
                                (!_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_other_articles_box, {
                                      key: 0,
                                      title: 'Favourite ' + _ctx.title + ' Articles',
                                      class: "mt-2"
                                    }, null, 8, ["title"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_upcoming_events_box, { class: "mt-2" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_ion_infinite_scroll, {
            onIonInfinite: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadData($event, true))),
            threshold: "100px",
            id: "infinite-scroll"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "crescent" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}